module.exports = __webpack_public_path__ + "img/bgb-ii.410df25a.jpg";